'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppInfo = getAppInfo;
exports.getBrowserInfo = getBrowserInfo;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAppInfo() {
  var qs = _queryString2.default.parse(location.search);

  var development = false;
  if (qs.dev != null && (qs.dev === 'false' || qs.dev === 'true')) {
    development = qs.dev === 'true';
  }

  return {
    name: window.APP_NAME || null,
    version: window.APP_VERSION || null,
    buildVariant: qs.variant || window.APP_BUILD_VARIANT || 'main',
    tracking: qs.tracking || null,
    instance: qs.instance || null,
    query: qs,
    development: development
  };
}

function getBrowserInfo() {
  var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem != null) {
      return { name: 'Opera', version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1]
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/getAppInfo.js
// module id = 22
// module chunks = 0